var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "187.6 117.6 324.8 324.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m350 117.6c-9.2773 0-16.801 7.5234-16.801 16.801v128.8h-128.8c-9.2773 0-16.801 7.5195-16.801 16.801 0 9.2773 7.5234 16.801 16.801 16.801h128.8v128.8c0 9.2773 7.5234 16.801 16.801 16.801s16.801-7.5234 16.801-16.801v-128.8h128.8c9.2773 0 16.801-7.5234 16.801-16.801s-7.5234-16.801-16.801-16.801h-128.8v-128.8c0-9.2773-7.5195-16.801-16.801-16.801z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.0ed3a9bd891155c953a94ce2ec329c93.svg";
export { ForwardRef as ReactComponent };